import { FreshMealPlanType } from "libs/api/customer/src/lib/types/checkout";
import { ICapiCustomData } from "@capi/types";
import { IGetPriceEstimateResponse, GTMProduct } from "@api-clients/checkout";
import type { TCatFormDataInput } from "@./suf-store";

export const transformCats = (cats: Record<string, TCatFormDataInput>, perCatPricing: IGetPriceEstimateResponse["cats"]) => {
  const updatedCats: Record<string, TCatFormDataInput> = { ...cats };
  for (const catId of Object.keys(updatedCats)) {
    const cat = updatedCats[catId];
    const catPricing = perCatPricing.find((pc) => pc.catName.toLowerCase() === cat.name?.toLowerCase());

    updatedCats[catId] = {
      ...cat,
      trialPricePerDay: catPricing?.trial.discounted.mealPlan.perDay,
      trialOriginalPricePerDay: catPricing?.trial.original.mealPlan.perDay,
      ongoingPricePerDay: catPricing?.ongoing.discounted.mealPlan.perDay,
    };
  }
  return updatedCats;
};

/**
 * Helper function to categorise a GTM product
 */
const categoriseGTMProduct = (gtmProduct: GTMProduct): string => {
  if (gtmProduct.name.includes("Delivery")) {
    return "Delivery Fee";
  }
  if (gtmProduct.name === "Sprinkles") {
    return "extra";
  }
  if (gtmProduct.id.includes("mealplan")) {
    return "meal_plan";
  }
  return "recipe";
};

/**
 * Creates CAPI custom data from Fresh Options Response for tracking purposes.
 * Uses the gtmProducts array which contains all items (recipes, extras, delivery, meal plan).
 */
export const createCapiCustomDataFromFreshOptions = (
  response: IGetPriceEstimateResponse,
  product: FreshMealPlanType = "FRESH_TRIAL",
): ICapiCustomData => {
  const { totals, discount, gtmProducts } = response;

  // Map gtmProducts directly to CAPI contents format
  const contents = gtmProducts?.map((gtmProduct) => ({
    id: gtmProduct.id,
    quantity: gtmProduct.quantity,
    itemPrice: Number.parseFloat(gtmProduct.price) || 0,
    title: gtmProduct.name,
    brand: gtmProduct.brand,
    deliveryCategory: "home_delivery" as const,
    category: categoriseGTMProduct(gtmProduct),
  })) || [];

  return {
    value: Number.parseFloat(totals.trial.discounted.overall.total),
    currency: "gbp",
    contentName: product,
    contentCategory: "fresh",
    contents,
    contentType: "product",
    numItems: response.cats.length,
    searchString: discount?.code,
    deliveryCategory: "home_delivery",
  };
};
